import { withProps } from 'recompose'

// TODO: rename function
const withFlattenedTranslations = queryName =>
  withProps(({ data }) => {
    const queryResult = data[queryName]

    if (queryResult) {
      return {
        [queryName]: queryResult
      }
    }
  })

export default withFlattenedTranslations



// WEBPACK FOOTER //
// ./src/hocs/withFlattenedTranslations.js